import styled from 'styled-components';

export const SettingWrapperContainer = styled.div`
  display: flex;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
`;

export const TabWrapper = styled.div`
  max-width: 260px;
  padding: 40px 20px 0px 0px;
  height: calc(100vh - 90px);
  border-right: 1px solid #8a8a8a;

  flex-shrink: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: none;
    padding: 0px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
    padding: 0px;
  }
`;

export const TabWrapperForMobile = styled.div`
  flex-shrink: 0;
  display: none;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: block;
    padding: 0px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-shrink: 1;
    display: block;
    /* padding: 0px; */
  }
`;

export const Wrapper = styled.div`
  padding: 30px 20px 0px 80px;
  flex: 1;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0px;
  }
`;
